(function () {
  if (window.__cardSwatchHoverInit) return;
  window.__cardSwatchHoverInit = true;

  function getPreviewImage(swatchEl) {
    var wrapper = swatchEl.closest('.card-wrapper');
    if (!wrapper) return null;
    return wrapper.querySelector('.card-swatch-preview-image');
  }

  function activateSwatch(swatchEl) {
    var img = getPreviewImage(swatchEl);
    if (!img) return;

    var url = swatchEl.getAttribute('data-swatch-image');
    if (url) img.setAttribute('src', url);

    img.classList.add('is-active');
    swatchEl.classList.add('is-active-swatch');
  }

  function deactivateSwatch(swatchEl) {
    var img = getPreviewImage(swatchEl);
    if (img) img.classList.remove('is-active');
    swatchEl.classList.remove('is-active-swatch');
  }

  function getSwatchAtPoint(x, y) {
    var el = document.elementFromPoint(x, y);
    if (!el) return null;
    return el.closest('.card-swatch[data-swatch-image]');
  }

  /* ---------- Desktop: mouse / teclado (foco) ---------- */

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest('.card-swatch[data-swatch-image]');
    if (swatch) activateSwatch(swatch);
  });

  document.addEventListener('mouseout', function (event) {
    var swatch = event.target.closest('.card-swatch[data-swatch-image]');
    if (!swatch) return;
    var related = event.relatedTarget;
    if (related && swatch.contains(related)) return;
    deactivateSwatch(swatch);
  });

  document.addEventListener('focusin', function (event) {
    var swatch = event.target.closest('.card-swatch[data-swatch-image]');
    if (swatch) activateSwatch(swatch);
  });

  document.addEventListener('focusout', function (event) {
    var swatch = event.target.closest('.card-swatch[data-swatch-image]');
    if (swatch) deactivateSwatch(swatch);
  });

  /* ---------- Móvil: deslizar el dedo sobre las bolitas ---------- */

  var activeTouchSwatch = null;
  var touchStartX = 0;
  var touchStartY = 0;
  var isDragging = false;
  var dragHappened = false;

  document.addEventListener(
    'touchstart',
    function (event) {
      var swatch = event.target.closest('.card-swatch[data-swatch-image]');
      if (!swatch) return;

      var touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      isDragging = false;
      activeTouchSwatch = swatch;
      activateSwatch(swatch);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!activeTouchSwatch) return;

      var touch = event.touches[0];
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;

      if (!isDragging) {
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) {
          isDragging = true;
        } else if (Math.abs(dy) > 6) {
          /* El dedo se mueve más en vertical: es scroll de página, no interferimos */
          deactivateSwatch(activeTouchSwatch);
          activeTouchSwatch = null;
          return;
        }
      }

      if (isDragging) {
        if (event.cancelable) event.preventDefault();
        var swatch = getSwatchAtPoint(touch.clientX, touch.clientY);
        if (swatch && swatch !== activeTouchSwatch) {
          deactivateSwatch(activeTouchSwatch);
          activeTouchSwatch = swatch;
          activateSwatch(swatch);
        }
      }
    },
    { passive: false }
  );

  function endTouch() {
    if (activeTouchSwatch) deactivateSwatch(activeTouchSwatch);
    dragHappened = isDragging;
    activeTouchSwatch = null;
    isDragging = false;
  }

  document.addEventListener('touchend', endTouch, { passive: true });
  document.addEventListener('touchcancel', endTouch, { passive: true });

  /* Evita que un "tap" corto (sin arrastrar) navegue de golpe sin dar tiempo
     a ver el preview; solo se bloquea la navegación si SÍ hubo arrastre. */
  document.addEventListener(
    'click',
    function (event) {
      var swatch = event.target.closest('.card-swatch[data-swatch-image]');
      if (swatch && dragHappened) {
        event.preventDefault();
      }
      dragHappened = false;
    },
    true
  );
})();
